import React from "react";
import { POSConfigToolContainer } from "@revenue-management/pos-config-tool";

import Header from "@/components/header";
import SimpleHeader from "@/components/header/SimpleHeader";
import Footer from "@/components/footer";
import Alerts from "@/components/alerts";
import ErrorBoundary from "@/components/error-boundary";
import { OKTA_WIDGET_CALLBACK_QS } from "@/constants/routes";

import { PageContainer, ContentContainer } from "./Page.styled";

export const PageWithNavigationLayout = (Component, hideNavbar) => (props) => (
  <PageContainer>
    <Header hideNavbar={hideNavbar} />
    <Alerts />
    <ContentContainer>
      <section className="primary-section">
        <ErrorBoundary>
          <Component {...props} />
        </ErrorBoundary>
      </section>
    </ContentContainer>
    <Footer />
  </PageContainer>
);

export const PageWithSimpleLayout = (Component) => (props) => (
  <PageContainer>
    <SimpleHeader />
    <ContentContainer>{Component && <Component {...props} />}</ContentContainer>
    <Footer />
  </PageContainer>
);

export const PageWithNoLayout = (Component) => (props) => (
  <PageContainer>
    <ContentContainer>{Component && <Component {...props} />}</ContentContainer>
  </PageContainer>
);

export const PageWithCallbackCheck =
  (CallbackPage, NoCallbackPage, Component) => (props) => {
    // The `location` prop is provided by React Router
    const qs = props.location?.search || "";

    // Route called by Okta, query string created by Okta
    const oktaIDPCheckCallback = qs.includes("fromLogin=true");

    // Route called by Okta, query string created by us
    const oktaSignInWidgetCallback = qs.includes(OKTA_WIDGET_CALLBACK_QS);

    // Roll all possible callbacks into a single check
    const isCallback = oktaIDPCheckCallback || oktaSignInWidgetCallback;

    const Page = isCallback ? CallbackPage : NoCallbackPage;

    return Page(Component)({ isCallback, ...props });
  };

export const POSConfigToolPage = ({ children, hideNavbar = false }) => {
  return (
    <PageContainer>
      <Header hideNavbar={hideNavbar} />
      <Alerts />
      <ContentContainer>
        <section className="primary-section">{children}</section>
      </ContentContainer>
      <Footer />
    </PageContainer>
  );
};

export const POSConfigToolAdminPage = (Component) => (props) => (
  <POSConfigToolPage>
    <POSConfigToolContainer history={props.history}>
      <Component />
    </POSConfigToolContainer>
  </POSConfigToolPage>
);
